/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// MR - Product Revies + Q&A - 11 Jun '19

function scrollToS(element) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop
  });
}

/*
if (document.body.classList.contains('template-product')) {
  
  var revBtn = document.getElementsByClassName('nw-prod-review')[0];

  revBtn.addEventListener('click', function(event) {
    var elm = document.querySelector('.Product__Aside .Collapsible__Button');
    scrollToS(elm);
    if ( elm.getAttribute('aria-expanded') == 'false' ){
      elm.click();
    }
  })


  //

  var qaBtn = document.getElementsByClassName('button-qa')[0];
  var qaPageBool = false;
  const askButton = document.getElementsByClassName('nw-ask-btn')[0];

  if ( productQuestionNumber > 0 ){
    var simPagInt = setInterval(checkSimPag, 50);
  }

  function checkSimPag(){
    var simPagElm = document.getElementsByClassName("simPagination")[0];
    if(typeof(simPagElm) != 'undefined' && simPagElm != null){
      //console.log('Element exists');
      clearInterval(simPagInt);
      if ( !qaPageBool){
        var prev = document.getElementsByClassName('simp-previous')[0];
        var next = document.getElementsByClassName('simp-next')[0];

        prev.textContent = 'PREVIOUS';
        prev.classList.add('Button');
        prev.classList.add('Button--secondary');
        next.textContent = 'NEXT';
        next.classList.add('Button');
        next.classList.add('Button--secondary');

        var pag = document.getElementsByClassName('simPagination')[0];
        pag.appendChild(askButton);

        qaPageBool = true;
      }

    }
  }

}
*/


// MR - Recommended Products - 04 Feb '20

function initRecSlide() {
  $('.nw-rec-sld').flickity({
    prevNextButtons: true,
    pageDots: false,
    wrapAround: false,
    contain: true,
    cellAlign: "center",
    watchCSS: true,
    dragThreshold: 8,
    groupCells: true,
    imagesLoaded: true,
    arrowShape: {x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25}
  });
  
}

function recSldResize(t) {
  setTimeout(function(){
    $('.nw-rec-sld').flickity('resize');
  }, t);
  
}

function izllv () {
  if( $(".bold-recommend__wrap")[0] ){
    var ths = $(this);
    
    $(".bold-recommend__wrap .bold-recommend__product").each(function(){
      $('.nw-rec-sld').append($(this));
      $(this).addClass('Carousel__Cell');
    });
    $('.template-product .nw-related-section').css('display', 'block');
    initRecSlide();

    recSldResize(50);
    recSldResize(200);
    recSldResize(500);
    recSldResize(2000);
  } else {
    setTimeout(izllv, 100);
  }
}


// MR - Multi Blog - 02 Aug '19

$(document).ready(function(){
  if (document.body.classList.contains('template-index')) {

    var multiBlog = {};
    multiBlog.type = '';
    multiBlog.artNo = 0;
    multiBlog.articles = {};

    $.ajax({
      cache: false,
      url: 'https://111skin.com/pages/multi-blog?view=broad-blog',
      dataType: "xml",
      success: function(data){
        multiBlog.type = $(data).find('type').text();

        $(data).find('article').each(function(i){
          multiBlog.artNo = multiBlog.artNo + 1;
          multiBlog.articles[i] = {};
          multiBlog.articles[i]['title'] = $(this).find('title').text();
          multiBlog.articles[i]['url'] = $(this).find('url').text();
          multiBlog.articles[i]['excerpt'] = $(this).find('excerpt').text();
          multiBlog.articles[i]['image'] = $(this).find('image').text();
          multiBlog.articles[i]['alt'] = $(this).find('alt').text();
          multiBlog.articles[i]['category'] = $(this).find('category').text();
        });

        $('.multi-blog-rec .nw-art-cont').each(function(i){
          if ( multiBlog.articles[i] !== undefined ){
            if ( multiBlog.articles[i].image !== undefined || multiBlog.articles[i].image !== '' ) {
              $(this).find('.ArticleItem__ImageWrapper').css('background-url', multiBlog.articles[i].image);
              $(this).find('.ArticleItem__ImageWrapper').prop('href', multiBlog.articles[i].url);
              $(this).find('.ArticleItem__ImageWrapper > img').prop('src', multiBlog.articles[i].image);
              $(this).find('.ArticleItem__ImageWrapper > img').prop('alt', multiBlog.articles[i].alt);
            } else {
              $(this).find('.ArticleItem__ImageWrapper').css('display', 'none');
            }
            $(this).find('.ArticleItem__Category').text(multiBlog.articles[i].category);
            $(this).find('.ArticleItem__Title').html('<a href="' + multiBlog.articles[i].url + '">' + multiBlog.articles[i].title + '</a>');
            $(this).find('.ArticleItem__Excerpt').text(multiBlog.articles[i].excerpt);
            $(this).find('.ArticleItem__Link').prop('href', multiBlog.articles[i].url);
          } else {
            $(this).css('display', 'none');
          }
        });
      }
    });
    

  }

  // MR - Recommended Products - 04 Feb '20

  if (document.body.classList.contains('template-product')) {
    izllv();

    $('.nw-rec-sld').on( 'dragStart.flickity', function() {
      $(this).addClass('is-dragging');
    });
    $('.nw-rec-sld').on( 'dragEnd.flickity', function() {
      $(this).removeClass('is-dragging');
    });
    
    
    // MR - Exclude Variant from Subscription - 15 Sep '21
    
    if (settingSubEnabled && subProductInCollection) {

      var varSubExclude = setInterval(function() {

        if ($('#rc_container').is(':visible')) {
          clearInterval(varSubExclude);

          let excludedVar = settingSubExcludedVar;
          let subVars = document.querySelectorAll('[data-value]');
          let subForm = document.querySelector('#rc_container');
          let initialVar = document.querySelector('.Select--primary select option:checked');

          subVars.forEach(variant =>
                          variant.addEventListener('click', e => {
            if (e.target.getAttribute('data-value') == excludedVar) {
              subForm.style.display = 'none'
              document.querySelector('#rc_container #rc_radio_options .rc_block__type__onetime input').click();
            } else {
              subForm.style.display = 'block'

            }
          })
                         )

          if (initialVar.getAttribute('data-title') == excludedVar) {
            subForm.style.display = 'none'
            document.querySelector('#rc_container #rc_radio_options .rc_block__type__onetime input').click();
          } else {
            subForm.style.display = 'block'
          }
        } 
      }, 100);

    }
  }
  
  
  
  // MR - Register + Recover - 02 Sep '20
  
  if (document.body.classList.contains('template-login')) {
    if ( window.location.href.indexOf('#recover') !== -1 ) {
      $('#customer_login').css('display', 'none');
      $('#recover_customer_password').css('display', 'block');
    }
  }
  
  
  // MR - Announcement Bar - 01 Dec '20

  $('.nw-sec-announce .nw-sec-close').on('click', function(e){
    e.preventDefault();
    $(this).parents('.nw-sec-announce').addClass('nw-sec-hide');
  });

  
});


// MR - Add To Cart Fix - 06 Mar '20
document.addEventListener('variant:changed', function(event) {
  $('.ProductForm .bold_clone').addClass('nw-b-hide');
});

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();



// MR - LoyaltyLion - 17 Aug '20

$('body').on('click', '.lion-loyalty-widget__body', function(evt){
  evt.preventDefault();
  evt.stopImmediatePropagation();
  window.location.href = '/pages/my-rewards';
});


// MR - ReCharge Pricing Update - 15 Sep '21

function updRecSubPrice(){
  if (typeof ReCharge != 'undefined'){
    
    var subPriceFormat = ReCharge.options.money_format;
    var subCurrency = subPriceFormat.replaceAll(' ', '');
    subCurrency = subCurrency.replaceAll('{{amount}}', '');
    
    var subRechargeProducts = ReCharge.products;

    subRechargeProducts.forEach(function(product){
      if(product.id == subProductId){
        
        var subVars = $('[data-value]');
        
        subVars.on('click', function(){
          var val = $(this).data('value');
          var variantId = $('.Select--primary select option[data-title="' + val + '"]').val();
          
          var oneTimePrice = product.variant_to_price[variantId];
          var duplicateVar = product.variant_to_duplicate[variantId];
          var subPrice = product.duplicate_to_price[duplicateVar];
          
          oneTimePrice = parseInt(oneTimePrice, 10);
          oneTimePrice = (oneTimePrice / 100).toFixed(2);
          
          subPrice = parseInt(subPrice, 10);
          subPrice = (subPrice / 100).toFixed(2);
          
          if ( subCurrency !== '' ){
            oneTimePrice = subCurrency + oneTimePrice;
            subPrice = subCurrency + subPrice;
          }
          
          $('#rc_price_onetime').html(oneTimePrice);
          $('#rc_price_autodeliver').html(subPrice);
          
        });
      }
    }
   );

  }
}

if (document.body.classList.contains('template-product')) {
  $(window).load(function(){
    updRecSubPrice();
  });
}